"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["[_nghost-%COMP%]{width:100%;min-width:100%;max-width:100%;margin-top:5px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;-moz-justify-content:space-between;-ms-justify-content:space-between;justify-content:space-between;-ms-flex-align:center;-moz-align-items:center;align-items:center}[_nghost-%COMP%]   .cancel-button[_ngcontent-%COMP%]{margin-right:10px;width:25%}[_nghost-%COMP%]   dln-button[_ngcontent-%COMP%]{width:75%;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}"];
exports.styles = styles;
